import {SetGetGgr} from './thunk/setGetGgr';
import {SetGetOperationsReplenishment} from './thunk/setGetOperationsReplenishment';
import {SetGetOperationsWithdrawal} from './thunk/setGetOperationsWithdrawal';

export const Thunks = {
    SetGetGgr,
    SetGetOperationsReplenishment,
    SetGetOperationsWithdrawal
}